import { useState, useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Badge, IconButton, Popover } from 'components/ui';
import { ProbelistNotificationsIcon } from 'components/uiIcons';
import useUnreadNotificationsCount from 'hooks/use_unread_notifications_count';
import Dropdown from 'components/notification/dropdown';
import theme from 'theme';

const BellButton = () => {
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { count } = useUnreadNotificationsCount();

  useEffect(() => {
    const appName = intl.formatMessage({ id: 'app_name' });
    document.title = count > 0 ? `(${count}) ${appName}` : appName;
  }, [count, intl]);

  const handleOpen = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <IconButton
        aria-label={intl.formatMessage({ id: 'aria.notifications.open' })}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-controls={open ? 'notifications-popover' : undefined}
        onClick={handleOpen}
        sx={
          open
            ? {
                backgroundColor: theme.palette.custom.whiteGreen,
                '&:hover': { backgroundColor: theme.palette.custom.whiteGreen },
              }
            : undefined
        }
      >
        <Badge badgeContent={count > 9 ? '9+' : count} color="error" invisible={count === 0}>
          <ProbelistNotificationsIcon aria-hidden="true" />
        </Badge>
      </IconButton>
      <Popover
        id="notifications-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Dropdown onClose={handleClose} />
      </Popover>
    </>
  );
};

export default BellButton;
